/* Klebrig kjøpsrad.
   Vises når produktskjemaets egen knapp ikke er i syne: rullet ut av syne
   oppover, eller ligger under skjermen (V3-04, V4-04). Før kom den bare
   OPPOVER-tilfellet, så det fantes et strekk der verken knapp eller rad var
   synlig: slirekniven har knappen 1 127 px nede, og mobilnettlesere viser
   ca. 620–670 px. Gjelder alle bredder (V3-11, V4-16).
   Speiler pris og tilgjengelighet fra siden i stedet for å regne på nytt,
   så raden aldri kan si noe annet enn det som står lenger opp.

   Fire ting raden gjør for å holde seg ærlig:

   1. Prisen slås opp på nytt hver gang. Dawn bytter innmaten i
      #price-<seksjon> når kunden velger en annen variant, og det som ble
      mellomlagret her tidligere (.price__container) ble dermed løsrevet fra
      dokumentet: raden viste 3.820 kr mens siden viste 3.378 kr. Wrapperen
      #price-<seksjon> består, og det er den vi observerer. Dessuten
      lytter vi på Dawns variantChange.
   2. Raden skjules når bunnteksten er i syne. Den dekket Visa, Mastercard,
      Klarna og Vipps og ©-linja.
   3. Raden vises ikke når knappen er deaktivert. På en utsolgt vare var den
      en grå «Utsolgt»-knapp som ikke kunne brukes til noe.
   4. Raden vises ikke mens kunden skriver i et felt i kjøpsboksen
      (graveringsfeltet, appens felt, nedtrekkslister). Tastaturet tar
      halve skjermen, og raden lå ellers oppå feltet og feilmeldingen. */
(function () {
  'use strict';

  const start = () => {
    const rad = document.querySelector('[data-gs-kjopsrad]');
    if (!rad) return;

    const skjemaKnapp = document.querySelector('.product-form__submit');
    if (!skjemaKnapp) return;

    const radKnapp = rad.querySelector('[data-gs-kjopsrad-knapp]');
    const radPris = rad.querySelector('[data-gs-kjopsrad-pris]');

    const seksjon = () => document.querySelector('product-info[data-section]')?.dataset.section || '';
    const prisBeholder = () => {
      const id = seksjon();
      return id ? document.getElementById('price-' + id) : null;
    };

    // Dawn har alltid prisen i .price__regular, også når varen er på tilbud.
    const lesPris = () => {
      const beholder = prisBeholder();
      const pris = beholder && beholder.querySelector('.price__regular .price-item--regular');
      return pris ? pris.textContent.replace(/\s+/g, ' ').trim() : '';
    };

    let knappSynlig = true;
    let bunnSynlig = false;
    let utsolgt = false;
    let iFelt = false;

    const vis = () => {
      const skalVises = !knappSynlig && !bunnSynlig && !utsolgt && !iFelt;
      rad.classList.toggle('er-synlig', skalVises);
      rad.setAttribute('aria-hidden', skalVises ? 'false' : 'true');
      radKnapp.tabIndex = skalVises ? 0 : -1;
    };

    // Knappen regnes som i syne bare når den står over der raden havner
    // (ca. 72 px nederst). Ligger den bak raden, er det raden som gjelder.
    new IntersectionObserver(
      ([post]) => {
        knappSynlig = post.isIntersecting;
        vis();
      },
      { threshold: 0, rootMargin: '0px 0px -72px 0px' }
    ).observe(skjemaKnapp);

    // Ikke oppå tastaturet og feltet kunden skriver i.
    const erFelt = (el) =>
      !!el &&
      !!el.matches &&
      el.matches('textarea, select, input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([type="submit"]):not([type="button"])') &&
      !!el.closest('.product__info-container');
    document.addEventListener('focusin', (h) => {
      if (erFelt(h.target)) {
        iFelt = true;
        vis();
      }
    });
    document.addEventListener('focusout', () => {
      setTimeout(() => {
        iFelt = erFelt(document.activeElement);
        vis();
      }, 0);
    });

    // Ikke over bunnteksten.
    const bunn = document.querySelector('footer');
    if (bunn) {
      new IntersectionObserver(
        ([post]) => {
          bunnSynlig = post.isIntersecting;
          vis();
        },
        { threshold: 0 }
      ).observe(bunn);
    }

    // Speil tilstand fra den ekte knappen — utsolgt, valgt variant, alt.
    const speil = () => {
      const av = skjemaKnapp.hasAttribute('disabled') || skjemaKnapp.getAttribute('aria-disabled') === 'true';
      utsolgt = skjemaKnapp.hasAttribute('disabled');
      radKnapp.disabled = av;
      radKnapp.textContent = utsolgt ? 'Utsolgt' : 'Legg i kurv';
      const pris = lesPris();
      if (radPris && pris) radPris.textContent = pris;
      vis();
    };
    speil();

    new MutationObserver(speil).observe(skjemaKnapp, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
    });

    // Prisbeholderen består, men innmaten byttes ut. Observer beholderen.
    let observert = null;
    const observerPris = () => {
      const b = prisBeholder();
      if (!b || b === observert) return;
      observert = b;
      new MutationObserver(speil).observe(b, { childList: true, characterData: true, subtree: true });
    };
    observerPris();

    // Dawns egen hendelse når en ny variant er hentet. Pris og knapp er da
    // allerede byttet, men et helt produktbytte kan bytte beholderen også.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        observerPris();
        speil();
      });
    }

    radKnapp.addEventListener('click', () => skjemaKnapp.click());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
